import React from 'react';
import {Col, Container, Row} from "reactstrap";
import Gallery from "../components/Gallery";
import projects from "../data/projects/projects.json";

function Projects(props) {

    return (
        <Container>

            <div className="section"/>

            <h1>Referanslarımız</h1>
            <h3 style={{marginBottom:20}}>Bizim için her proje yeni bir hikâye demek. Bugüne kadar birçok değerli iş ortağımızla birlikte farklı
                sektörlerde projeler geliştirdik. Attığımız her adımda güven, şeffaflık ve başarıyı ön planda tuttuk.
                İşte işbirliği yapmaktan mutluluk duyduğumuz bazı projeler</h3>


            <div className="row">
                {projects.map((project, index) => (
                    <div className="col-md-4 col-sm-6" key={index}>

                        <a className="project-card-1" href={`projects/${project.slug}`}>
                            <article className="card">
                                <img
                                    className="card__background"
                                    src={project.images[0]}
                                    alt={project.name}
                                />
                                <div className="card__content | flow">
                                    <div className="card__content--container | flow">
                                        <h2 className="card__title">{project.name}</h2>
                                        <p className="card__description">
                                            {project.city}
                                        </p>
                                    </div>
                                    <button className="card__button">Devamını Gör</button>
                                </div>
                            </article>
                        </a>
                    </div>

                ))}


            </div>


        </Container>
    );
}

export default Projects;
